import React from "react";
import { useTranslation } from "react-i18next";

import "./PlanningSummary.scss";

export interface PlanningSummaryProps {
  incompleteAssignments: number;
  studentsStruggling: number;
  studentsShowedGrowth: number;
  studentsNotReady: number;
  skillsToBeTaught: number;
  studentsUnderbooked: number;
}

export const PlanningSummary: React.FC<PlanningSummaryProps> = ({
  incompleteAssignments,
  studentsStruggling,
  studentsShowedGrowth,
  studentsNotReady,
  skillsToBeTaught,
  studentsUnderbooked
}) => {
  if (
    incompleteAssignments === 0 
    && studentsStruggling === 0 
    && studentsShowedGrowth === 0 
    && skillsToBeTaught === 0 
    && studentsNotReady === 0 
    && studentsUnderbooked === 0
  ) return null;
  const { t } = useTranslation('planner');
  return <article className="planning-summary px-5 pt-5 pb-4">
    <header>
      <h4>{t('SUMMARY_HEADER')}</h4>
    </header>
    <div className="d-flex gap-5">
      { (incompleteAssignments > 0 || studentsStruggling > 0 || studentsShowedGrowth > 0) && (
      <div className="col">
        <header>
          <h5>{t('TAKE_ACTION_HEADER')}</h5>
        </header>
        <ul>
        { incompleteAssignments > 0 && (
          <li className="planning-summary-item incomplete">{t('INCOMPLETE_ASSIGNMENTS', {count: incompleteAssignments})}</li>
        )}
        { studentsStruggling > 0 && (
          <li className="planning-summary-item struggling">{t('STUDENTS_STRUGGLING', {count: studentsStruggling})}</li>
        )}
        { (incompleteAssignments === 0 || studentsStruggling === 0) && studentsShowedGrowth > 0 && (
          <li className="planning-summary-item growth">{t('STUDENTS_SHOWED_GROWTH', {count: studentsShowedGrowth})}</li>
        )}
        </ul>
      </div>
      )}
      {(skillsToBeTaught > 0 || studentsNotReady > 0 || studentsUnderbooked > 0) && (
      <div className="col">
        <header>
          <h5>{t('TO_DO_HEADER')}</h5>
        </header>
        <ul>
          { skillsToBeTaught > 0 && (
            <li className="planning-summary-item skills">{t('SKILLS_TO_BE_TAUGHT', {count: skillsToBeTaught})}</li>
          )}
          { studentsNotReady > 0 && (
            <li className="planning-summary-item not-ready">{t('STUDENTS_NOT_READY', {count: studentsNotReady})}</li>
          )}
          { (skillsToBeTaught === 0 || studentsNotReady === 0) && studentsUnderbooked > 0 && (
            <li className="planning-summary-item underbooked">{t('STUDENTS_UNDERBOOKED', {count: studentsUnderbooked})}</li>
          )}
        </ul>
      </div>
      )}
    </div>
</article>;
};

export default PlanningSummary;